import { createRouter, createWebHistory } from 'vue-router'

import { ROUTES } from '@/config/ROUTES.ts'
import { type LocalizedRoute, localizedRoutes } from '@/extensions/langRouter'
import i18n from '@/i18n'

const routes: LocalizedRoute[] = [
  {
    path: '/',
    name: ROUTES.HOME,
    component: () => import('@/views/HomePage.vue'),
  },
  {
    path: '/faq',
    name: ROUTES.FAQ,
    component: () => import('@/views/FaqPage.vue'),
  },
  {
    path: '/politique-de-confidentialite',
    paths: { en: '/privacy-policy' },
    name: ROUTES.PRIVACY_POLICY,
    component: () => import('@/views/PrivacyPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch-all',
    component: () => import('@/views/NotFoundPage.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: '-active',
  linkExactActiveClass: '-exact-active',
  routes: localizedRoutes(routes, ['fr', 'en']),
  scrollBehavior(to, from) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: window.innerWidth > 1024 ? 115 : 90,
      }
    }

    if (to.name === from.name) {
      return { top: 0, behavior: 'smooth' }
    }

    return new Promise((resolve) => setTimeout(() => resolve({ top: 0 }), 200))
  },
})

router.beforeEach((to, _, next) => {
  i18n.global.locale.value = to.meta.locale as Locale
  next()
})

export default router
